import { IDataArray } from './../index';

export interface ISecurityQuestion {
    SeuciryQuestionId: number;
    Question: string;
}

export class SecurityQuestion implements IDataArray, ISecurityQuestion {
    public SeuciryQuestionId: number;
    public Question: string;
    public Id: number;

    public Answered = false;

    public GetById(): number {
        return this.Id;
    }
}
